export default "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"16\" viewBox=\"0 0 17 16\"><path d=\"M4.5 7H12.5V9H4.5z\"/></svg>";